import React from 'react'
import { Routes, Route, useNavigate, useParams } from 'react-router-dom'
import { useNavigate, useParams } from 'react-router-dom'

import CircularProgress from '@mui/material/CircularProgress'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'
import Stack from '@mui/material/Stack'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import { DataGrid } from '@mui/x-data-grid'
import FormControlLabel from '@mui/material/FormControlLabel'
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile'


import useStateObject from '~/client/hooks/useStateObject'
import { useQuery, useCommand } from '~/client/hooks/cqrpc'
import { useCurrentUser } from '~/client/hooks/auth'
import useToggle from '~/client/hooks/useToggle'

import Link from '~/client/components/Link'
import Heading from '~/client/components/Heading'
import ButtonRow from '~/client/components/ButtonRow'
import ErrorMessage from '~/client/components/ErrorMessage'
import DocumentTypeCreateForm from '~/client/components/DocumentTypeCreateForm'
import Timestamp from '~/client/components/Timestamp'
import LoadingList from '~/client/components/LoadingList'
import DocumentTypeFormPreview from '~/client/components/DocumentTypeFormPreview'
import InspectObject from '~/client/components/InspectObject'

export default function Page(props) {
  const { documentTypeId } = useParams()
  const { currentUser } = useCurrentUser()
  const query = useQuery('documentTypes.getById', { id: documentTypeId })
  const documentType = query.result
  console.log({ documentType })
  if (query.resolved && !documentType) return <div>not found</div>
  return <Container>
    <Breadcrumbs my={2}>
      <Link variant="text" to="/documents">documents</Link>
      <Link variant="text" to="/documents/types">types</Link>
    </Breadcrumbs>
    <Paper sx={{p: 2, my: 1}}>
      <ErrorMessage error={query.error}/>
      {query.pending ? <CircularProgress/> : null}
      {documentType
        ? <>
          <Typography variant="h6">Name: {documentType.name}</Typography>
          <Typography
            variant="body2"
            component="p"
            sx={{whiteSpace: 'pre-wrap'}}
          >{documentType.description}</Typography>

          <Button
            variant="text"
            component={Link}
            to={`/documents/types/${documentType.id}/edit`}
          >EDIT</Button>

          {/*<Stack spacing={2} direction="row">*/}
          {/*  <Box sx={{*/}
          {/*    backgroundColor: 'background.paper',*/}
          {/*    whiteSpace: 'pre-wrap',*/}
          {/*    p: 2,*/}
          {/*    fontFamily: 'monospace',*/}
          {/*  }}>{JSON.stringify(documentType.schema, null, 2)}</Box>*/}

          {/*  <Box sx={{*/}
          {/*    backgroundColor: 'background.paper',*/}
          {/*    whiteSpace: 'pre-wrap',*/}
          {/*    p: 2,*/}
          {/*    fontFamily: 'monospace',*/}
          {/*  }}>{JSON.stringify(documentType.uiSchema, null, 2)}</Box>*/}
          {/*</Stack>*/}
        </>
        : null
      }
    </Paper>
    {documentType
      ? <Paper sx={{p:2}}>
        <Heading>DOCUMENT FORM PREVIEW</Heading>
        <DocumentTypeFormPreview {...{documentType}}/>
      </Paper>
      : null
    }
  </Container>
}
